type LoadScriptOptions = {
  src?: string
  snippet?: string
  id: string
}

/**
 * Dynamically loads a script into the document head.
 *
 * @param options.src - The source URL of the script to load.
 * @param options.snippet - The script content to inject directly.
 * @param options.id - A unique identifier for the script element. Ex: 'google-maps'
 */
export function loadScript(options: LoadScriptOptions): Promise<void> {
  return new Promise((resolve, reject) => {
    const { src, snippet } = options
    const id = `skill-script-${options.id}`

    // Check if script already exists by id
    if (document.getElementById(id)) {
      return resolve()
    }

    const script = document.createElement('script')
    script.id = id

    if (src) {
      script.src = src
      script.async = true
      script.onload = () => resolve()
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
    } else if (snippet) {
      script.textContent = snippet
      document.head.appendChild(script)
      return resolve()
    } else {
      return reject(new Error('Either src or snippet must be provided.'))
    }

    document.head.appendChild(script)
  })
}
